
import React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent

// Add a controlled version of the Collapsible component
const ControlledCollapsible = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root> & {
    onOpenChange?: (open: boolean) => void;
  }
>(({ children, ...props }, ref) => (
  <CollapsiblePrimitive.Root {...props} ref={ref}>
    {children}
  </CollapsiblePrimitive.Root>
));
ControlledCollapsible.displayName = "ControlledCollapsible";

export { Collapsible, CollapsibleTrigger, CollapsibleContent, ControlledCollapsible }
